const namespace = 'EH:';

export const COOKIE_CONSENT_CHANGED = `${namespace}CookieConsentChanged`;
